var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_76",
    "data-name": "Group 76",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 43.347,
    height: 45.074,
    viewBox: "0 0 43.347 45.074",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2670",
    "data-name": "Rectangle 2670",
    width: 43.347,
    height: 45.074,
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_57",
    "data-name": "Group 57",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_47",
    "data-name": "Line 47",
    x2: 21.607,
    y2: 21.607,
    transform: "translate(21.162 21.162)",
    fill: "none",
    stroke: "#344154",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.157
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_988",
    "data-name": "Path 988",
    d: "M15.892,25.3S10,17.738,17.876,9.948A12.863,12.863,0,0,0,21.944.866S36.059,14.313,26.156,25.3l-.411.448",
    fill: "none",
    stroke: "#344154",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.157
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_989",
    "data-name": "Path 989",
    d: "M28.326,10.221a7.492,7.492,0,0,0,4.426-4.1S40.4,15.978,34.3,25.3",
    fill: "none",
    stroke: "#344154",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.157
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_990",
    "data-name": "Path 990",
    d: "M16.939,10.947s-3.858-.462-5.378-3.5c0,0-8.923,9.391-2.171,17.942",
    fill: "none",
    stroke: "#344154",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.157
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_991",
    "data-name": "Path 991",
    d: "M13.341,36.054a21,21,0,0,1-11.46-23.5",
    fill: "none",
    stroke: "#344154",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.157
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_992",
    "data-name": "Path 992",
    d: "M42.759,16.73a20.968,20.968,0,0,1-8.88,17.149",
    fill: "none",
    stroke: "#344154",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.157
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_48",
    "data-name": "Line 48",
    x2: 9.193,
    y2: 9.193,
    transform: "translate(0.578 0.578)",
    fill: "none",
    stroke: "#344154",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.157
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_49",
    "data-name": "Line 49",
    x1: 8.966,
    y2: 8.966,
    transform: "translate(0.579 33.803)",
    fill: "none",
    stroke: "#344154",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.157
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_50",
    "data-name": "Line 50",
    x1: 8.321,
    y2: 8.321,
    transform: "translate(34.448 0.578)",
    fill: "none",
    stroke: "#344154",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.157
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_993",
    "data-name": "Path 993",
    d: "M24.677,33.685,20.77,37.592h3.907l-3.6,3.6",
    fill: "none",
    stroke: "#344154",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.157
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    cx: 7.059,
    cy: 7.059,
    r: 7.059,
    transform: "translate(15.665 30.378)",
    fill: "none",
    stroke: "#344154",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.157
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNat);
export default __webpack_public_path__ + "static/media/nat.243e96d3d1f7213704f85b7863629f78.svg";
export { ForwardRef as ReactComponent };